import axios, { AxiosResponse } from 'axios';

import { HSCAN_BACKEND_API_URL } from '../../env';

export const requestVerifyOnSiteLink = (uri: string) => {
  return axios.put<void, AxiosResponse<void>, string>(
    `${HSCAN_BACKEND_API_URL}/link/onsite/verify/${uri}`,
  );
};

// ======= share-to-patient =======

export interface SignUpPresetResponse {
  presetId: string;
}
export const requestSignUpForShareToPatient = (uri: string) => {
  return axios.get<SignUpPresetResponse>(
    `${HSCAN_BACKEND_API_URL}/link/share-to-patient/${uri}/signup`,
  );
};

export interface ShareToPatientLink {
  uri: string;
  endAt: string;
  failureCount: number;
}
export const requestShareToPatientLink = (uri: string) => {
  return axios.get<ShareToPatientLink>(
    `${HSCAN_BACKEND_API_URL}/link/share-to-patient/${uri}`,
  );
};

export interface ShareToPatientChallenge {
  id: string;
  link: string;
  isPassed: boolean;
  endAt: string;
  version: number;
}
export const requestShareToPatientChallenge = (uri: string) => {
  return axios.post<ShareToPatientChallenge>(
    `${HSCAN_BACKEND_API_URL}/link/share-to-patient/${uri}/challenge`,
  );
};

export interface SolveChallengeRequest {
  uri: string;
  id: string;
  gender: string;
  birth: string;
}
export const requestShareToPatientAnswer = ({
  uri,
  id,
  ...params
}: SolveChallengeRequest) => {
  return axios.put<ShareToPatientChallenge>(
    `${HSCAN_BACKEND_API_URL}/link/share-to-patient/${uri}/challenge/${id}`,
    params,
  );
};

// ======= QR code =======

export interface QrCodeLink {
  /**
   * yyyy-mm-ddThh:MM:ss
   */
  expiredTime: string;
  failureCount: number;
}

export interface QrChallenge {
  id: string;
  link: string;
  isPassed: boolean;
  endAt: string;
  version: number;
}

export const requestQrCodeLink = (uri: string) => {
  return axios.get<QrCodeLink>(`${HSCAN_BACKEND_API_URL}/link/qr/${uri}`);
};

export const requestCreateQrChallenge = (uri: string) => {
  return axios.post<QrChallenge>(
    `${HSCAN_BACKEND_API_URL}/link/qr/${uri}/challenge`,
  );
};

export const requestSolveQrChallenge = ({
  uri,
  id,
  ...params
}: SolveChallengeRequest) => {
  return axios.put<QrChallenge>(
    `${HSCAN_BACKEND_API_URL}/link/qr/${uri}/challenge/${id}`,
    params,
  );
};

// ======= store-delegate =======

export interface StoreDelegateLink {
  endAt: string;
  failureCount: number;
}
export const requestStoreDelegateLink = (uri: string) => {
  return axios.get<StoreDelegateLink>(
    `${HSCAN_BACKEND_API_URL}/link/store/delegate/${uri}`,
  );
};

export interface RequestStoreDelegateAgreementParams {
  uri: string;
}
export const requestStoreDelegateAgreement = ({
  uri,
}: RequestStoreDelegateAgreementParams) => {
  return axios.put(
    `${HSCAN_BACKEND_API_URL}/link/store/delegate/${uri}/member`,
  );
};

export interface RequestStoreDelegateVerificationParams {
  uri: string;
}
export interface RequestStoreDelegateVerificationBody {
  gender: string;
  birth: string;
}
export const requestStoreDelegateVerification = ({
  uri,
  ...body
}: RequestStoreDelegateVerificationParams &
  RequestStoreDelegateVerificationBody) => {
  return axios.put<
    unknown,
    AxiosResponse<unknown>,
    RequestStoreDelegateVerificationBody
  >(`${HSCAN_BACKEND_API_URL}/link/store/delegate/${uri}/nonmember`, body);
};
